import React from 'react'

interface CustomTableProps extends React.PropsWithChildren {
  className?: string
}

const CustomTable = ({ children, className }: CustomTableProps) => {
  return <table className={`min-w-full ${className || ''}`}>{children}</table>
}

export default CustomTable